module.exports = __webpack_public_path__ + "img/14.ae89a0de.jpg";